import FetchFactory from '../factory'

interface IFaqs {
  params: {
    topic_id: string
  }
}

class FaqModule extends FetchFactory<any> {
    async getTopics() {
        return await useAsyncData(() => {
            return super.call('/api/lp/faq-topics', {
                method: 'GET',
      })
        })
    }

    async getFaqs(payload: IFaqs) {
        const { params } = payload
        return await useAsyncData(() => {
            return super.call(`/api/lp/faq-topics/${params.topic_id}/faqs`, {
                method: 'GET',
      })
        })
    }
}

export default FaqModule
